var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iq-team2 text-center"},[_c('div',{staticClass:"team-content"},[_vm._t("cardMedia")],2),_vm._v(" "),_c('div',{staticClass:"avtar-name iq-mt-20 iq-font-white text-center"},[_vm._t("cardTitle")],2),_vm._v(" "),_c('div',{staticClass:"team-social iq-mt-10"},[_vm._t("cardFooter")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }